import Service from './service'
import ServiceOperation from './service-operation'
import REQUEST_HEADERS from './request-headers'

import Logger from '@/logger'

/**
 * Gateway for accessing the lite auth tests service.
 * @export TestService
 * @class TestService
 */
export default class TestService extends Service {

    /**
     * Creates an instance of TestService.
     */
    constructor() {
        super('/test', 'Test')
    }

    /**
     * Determines whether the app is being operated by a signed in user.
     *
     * @param {?string} bearerToken Optional brearer token to override any current in state/
     * @returns {Promise<ServiceOperation>} The operation result.
     */
    async isAuthorisedHouseholderAsync(bearerToken = null) {
        const operationState = new ServiceOperation('User Authorisation Check', true)
        const url = 'system-user'
        Logger.log(`${ this.baseUrl }/${ url }`, 'Request [GET]')
        let result

        try {
            const config = this._buildAxiosConfig()

            if (bearerToken)
                config.headers[REQUEST_HEADERS.BEARER_TOKEN] = `Bearer ${ bearerToken }`

            result = await this.axios.get(url, config)
        } catch (err) {
            this._failOperation(err, operationState, 'isAuthorisedHouseholderAsync')
            return operationState
        }
        return this._processData(result, operationState, 'isAuthorisedHouseholderAsync')
    }

    /**
     * Verifies the state of the backend services.
     *
     * @param {number} schemeId
     * @returns {Promise<ServiceOperation>} The operation result.
     */
    async loadServiceDiagnosticsAsync(schemeId) {
        const operationState = new ServiceOperation('API Diagnostics Check', true)
        const url = `api-diagnostics/${ schemeId }`
        Logger.log(`${ this.baseUrl }/${ url }`, 'Request [GET]')

        return await this._processGet(url, operationState, 'loadServiceDiagnostics')
    }
}
